import React, { createContext, useContext, useMemo, useState } from "react"

export interface FindReplaceState {
  findText: string
  currentMatchIndex: number
  matches: Array<{
    testCaseId: string
    field:
      | "input_str"
      | "expected_behaviors"
      | "expected_output_json"
      | "script_turns"
    fieldKey?: string
  }>
}

export interface FindReplaceContextType {
  findReplaceState: FindReplaceState | null
  setFindReplaceState: (state: FindReplaceState | null) => void
}

const FindReplaceContext = createContext<FindReplaceContextType | undefined>(
  undefined,
)

export const FindReplaceProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [findReplaceState, setFindReplaceState] =
    useState<FindReplaceState | null>(null)

  const value = useMemo(
    () => ({
      findReplaceState,
      setFindReplaceState,
    }),
    [findReplaceState],
  )

  return (
    <FindReplaceContext.Provider value={value}>
      {children}
    </FindReplaceContext.Provider>
  )
}

export const useFindReplaceContext = (): FindReplaceContextType => {
  const context = useContext(FindReplaceContext)
  if (context === undefined) {
    throw new Error(
      "useFindReplaceContext must be used within a FindReplaceProvider",
    )
  }
  return context
}
